import {
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  InputGroup,
  Placeholder,
  Row,
  Table,
} from "react-bootstrap";
import { HeadPage } from "src/componentes";
import TributacaoCode from "./Tributacao.Code";
import { useEffect, useState } from "react";
import { IRoute } from "src/interfaces/IRoute";
import { useNavigate } from "react-router-dom";

const TributacaoView = () => {
  const [menuItens, setMenuItens] = useState<IRoute[]>([]);
  const [tipoFiltro, setTipoFiltro] = useState<string>("Nome");
  const navigate = useNavigate();
  const { register, errors, handleSubmit, onSubmit, loading, data, setValue } =
    TributacaoCode();

  useEffect(() => {
    setMenuItens([
      { name: "Nova Tributacao...", route: "/fiscal/tributacao/cadastro" },
    ]);
  }, []);

  const handleClickNavigate = (route: string) => () => {
    navigate(route);
  };

  const handleClickAlterar = (id: number) => () => {
    navigate(`/fiscal/tributacao/cadastro?id=${id}`);
  };

  const handleSelect = (value: number) => {
    setValue("tipoFiltro", value);
    setTipoFiltro(value === 0 ? "Nome" : value === 1 ? "Cfop" : "Opções");
  };

  return (
    <Container>
      <HeadPage headText="Tributação">
        {menuItens !== undefined &&
          menuItens.map((item) => (
            <Dropdown.Item
              key={item.name}
              onClick={handleClickNavigate(item.route)}
            >
              {item.name}
            </Dropdown.Item>
          ))}
      </HeadPage>
      <Row>
        <Col>
          <Form noValidate onSubmit={handleSubmit(onSubmit)}>
            <InputGroup hasValidation>
              <FloatingLabel controlId="pesquisar" label="Pesquisar">
                <Form.Control
                  type="text"
                  placeholder="Pesquisar"
                  isInvalid={!!errors.valor?.message?.toString()}
                  {...register("valor")}
                />
                {errors.valor?.message?.toString() && (
                  <Form.Control.Feedback type="invalid">
                    {errors.valor?.message?.toString()}
                  </Form.Control.Feedback>
                )}
              </FloatingLabel>
              <Dropdown align="end">
                <Dropdown.Toggle variant="link" id="dropdown-basic">
                  {tipoFiltro}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleSelect(0)}>
                    Nome
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => handleSelect(1)}>
                    Cfop
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </InputGroup>
          </Form>
        </Col>
      </Row>
      <Row>
        {!loading ? (
          <Col>
            {data && data.length > 0 ? (
              <Table responsive striped hover>
                <thead>
                  <tr>
                    <th className="col-6">Nome</th>
                    <th className="col-4">Cfop</th>
                    <th className="d-none d-sm-table-cell col-2">Operação</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item) => (
                    <tr
                      key={item.id}
                      onClick={handleClickAlterar(item.id)}
                      style={{ cursor: "pointer" }}
                    >
                      <td className="col-6">{item.nome}</td>
                      <td className="col-4">
                        {item.cfop.map(
                          (item, index) => (index > 0 ? "-" : "") + item.cfop
                        )}
                      </td>
                      <td className="d-none d-sm-table-cell col-2">
                        {item.tipoOperacao} - {item.tipoOperacaoDescricao}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <Form.Text>Sem Dados</Form.Text>
            )}
          </Col>
        ) : (
          <Placeholder as={FloatingLabel} animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Row>
    </Container>
  );
};
export default TributacaoView;
